import { render, staticRenderFns } from "./register-page.vue?vue&type=template&id=682e63ec"
import script from "./register-page.vue?vue&type=script&lang=js"
export * from "./register-page.vue?vue&type=script&lang=js"
import style0 from "./register-page.vue?vue&type=style&index=0&id=682e63ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports